<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
  },
  methods: {
    
  },
  created() {
    
  }
};
</script>

<style lang="less">
@import "style/common.less";
@import "style/aui/aui.css";
</style>


// WEBPACK FOOTER //
// src/App.vue